'use strict';

var implementation$1 = require('./implementation.js');

var implementation = implementation$1;

var polyfill = function getPolyfill() {
	if (typeof document !== 'undefined') {
		if (document.contains) {
			return document.contains;
		}
		if (document.body && document.body.contains) {
			return document.body.contains;
		}
	}
	return implementation;
};

module.exports = polyfill;
